import React, { useState, useEffect } from 'react'
import s from '@pagestyles/Blog.module.scss'
import getBlogcategories, {
    Blogsidebarcat,
    GetBlogsidebarCategory
} from '@pylot-data/api/operations/get-blogcategories'
import Link from 'next/link'
import { useRouter } from 'next/router'

interface BlogSubCategoryList {
    id: number
    parentCategory: Blogsidebarcat
    categoryData: Array<Blogsidebarcat>
}

export const CategoriesSidebar: React.FC = () => {
    const [posts, setPosts] = useState<BlogSubCategoryList[]>([])
    const categoryurl = '/blog/category/'
    const router = useRouter()
    const { locale } = router

    useEffect(() => {
        const fetchdatacategorylist = async () => {
            const categoryData = await getBlogcategories({
                pageSize: 5,
                locale: locale || ''
            })
            if (!categoryData) {
                return {
                    notFound: true
                }
            }
            setParentCategory(categoryData)
        }

        fetchdatacategorylist()
    }, [])

    const setParentCategory = (categoryData: GetBlogsidebarCategory) => {
        const subCategoryArray: BlogSubCategoryList[] = []
        if (categoryData?.blogCategories?.items.length) {
            categoryData.blogCategories.items.forEach((ls) => {
                const getCategory = subCategoryArray.find(
                    (el) => el && el.id === ls.parent_category_id
                )
                if (!getCategory) {
                    subCategoryArray.push({
                        id: ls.category_id,
                        parentCategory: ls,
                        categoryData: []
                    })
                    return
                }
                getCategory.categoryData.push(ls)
            })
        }
        setPosts(subCategoryArray)
    }

    return (
        <div className={s['categoryList']}>
            {posts.map((post: BlogSubCategoryList) => {
                return (
                    <div key={post.parentCategory?.category_id}>
                        <Link
                            href={`${categoryurl}${post.parentCategory.identifier}`}
                        >
                            {post.parentCategory.title}
                        </Link>
                        {post.parentCategory.posts_count > 0 && (
                            <span className={s['count']}>
                                ({post.parentCategory.posts_count})
                            </span>
                        )}
                        {post?.categoryData.length !== 0 && (
                            <ul>
                                {post.categoryData.map((subCategory, index) => {
                                    return (
                                        <li key={`subCategory_${index}`}>
                                            <Link
                                                href={`${categoryurl}${subCategory.identifier}`}
                                            >
                                                {subCategory.title}
                                            </Link>
                                            {subCategory.posts_count > 0 && (
                                                <span className={s['count']}>
                                                    ({subCategory.posts_count})
                                                </span>
                                            )}
                                        </li>
                                    )
                                })}
                            </ul>
                        )}
                    </div>
                )
            })}
        </div>
    )
}
